import { validateFrontendEnv } from "./env-contract.mjs";

export type AppEnvironment = "local" | "staging" | "production";

export interface FrontendEnv {
  VITE_APP_ENV: AppEnvironment;
  VITE_SUPABASE_URL: string;
  VITE_SUPABASE_ANON_KEY: string;
  VITE_BACKEND_URL: string;
  VITE_SENTRY_DSN?: string;
}

export const env = validateFrontendEnv({
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
}) as FrontendEnv;
